var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "relative flex flex-row items-center justify-between" },
        [
          _vm._t("parent-nav-link"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "w2 inline-flex pointer arrow-down-icon",
              class: { "is-clicked": _vm.subNavMenuItemClicked },
              on: {
                click: function ($event) {
                  _vm.subNavMenuItemClicked = !_vm.subNavMenuItemClicked
                },
              },
            },
            [
              _c("simple-svg", {
                class: "white-arrow",
                attrs: {
                  filepath: "/uploads/plus.svg",
                  id: "arrow-down-icon-id",
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade-rev" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.subNavMenuItemClicked,
                expression: "subNavMenuItemClicked",
              },
            ],
            staticClass: "relative pt3 is-tablet-regular",
          },
          [_vm._t("sub-nav-links")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }